var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataBroadcast = function SvgNoDataBroadcast(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9.0-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.7.0-Minc-Admin-/-Marketing-messages--empty",
    transform: "translate(-809.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "01.Icon/01.Basic/Fill/24/calendar-clear",
    transform: "translate(25.416667, 25.413316)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04166667,9.37835022 L1.04166667,9.42131897 C1.04012859,9.68974459 0.943211976,9.94888116 0.768229171,10.1524388 L0.768229171,10.155694 C0.416666669,10.5710586 0,11.3145481 0,12.5033502 C0,13.5808242 0.345052085,14.3412409 0.76041667,14.8412409 C0.942655931,15.0630292 1.04208572,15.3412945 1.04166667,15.6283503 L1.04166667,15.6283503 C1.04166667,16.7789435 1.97440678,17.7116836 3.12500002,17.7116836 L3.64583335,17.7116836 C3.93348166,17.7116836 4.16666669,17.4784986 4.16666669,17.1908503 L4.16666669,7.81585021 C4.16666669,7.5282019 3.93348166,7.29501688 3.64583335,7.29501688 L3.12500002,7.29501688 C1.97440678,7.29501688 1.04166667,8.22775698 1.04166667,9.37835022 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3554689,10.0651992 L27.294922,10.0541315 C27.1721203,10.0306904 27.083304,9.92329102 27.0833335,9.7982721 L27.0833335,1.95647518 C27.0833335,1.13355851 26.5371095,0.393975174 25.7233074,0.112725173 C24.9472657,-0.154852954 24.138672,0.0632460057 23.6608074,0.668063717 C22.6442109,1.88201222 21.5267271,3.00777206 20.3203126,4.03329811 C18.7819011,5.33538145 17.3098959,6.26311583 15.9583334,6.78785541 C15.7565606,6.86478417 15.6231853,7.05824309 15.623047,7.27418354 L15.623047,17.3861628 C15.6233902,17.8023589 15.8714428,18.1784057 16.2539063,18.342543 C17.5130209,18.8822565 18.873698,19.7637669 20.2903647,20.9649388 C21.5058607,21.9997475 22.6314205,23.1357615 23.654948,24.3607722 C23.9873413,24.7777759 24.4955136,25.0154849 25.028646,25.0033503 C25.2598209,25.0023254 25.489322,24.9640752 25.7083335,24.890069 C26.5436199,24.6127253 27.0833335,23.8998347 27.0833335,23.076267 L27.0833335,15.2071263 C27.0834441,15.0802198 27.1750168,14.9718727 27.3001303,14.9506159 L27.3554689,14.9415013 C27.981771,14.7715794 29.1666668,14.0443659 29.1666668,12.5033502 C29.1666668,10.9623346 27.981771,10.2351211 27.3554689,10.0651992 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5416667,18.7533503 L13.5416667,7.81585021 C13.5416667,7.5282019 13.3084817,7.29501688 13.0208334,7.29501688 L6.77083337,7.29501688 C6.48318506,7.29501688 6.25000003,7.5282019 6.25000003,7.81585021 L6.25000003,27.607517 C6.25000003,28.4704619 6.94955511,29.1700915 7.81250004,29.1700915 L11.2272136,29.1700915 C11.8850163,29.1755172 12.5083252,28.8762424 12.9153646,28.3594701 C13.3334332,27.8235708 13.4603371,27.115978 13.2545574,26.4681941 C13.1490886,26.1309545 13.0182292,25.7520482 12.8789063,25.3490534 C12.3639324,23.858168 11.6848959,22.935642 11.5039063,20.8360326 C12.6364105,20.8112531 13.5415838,19.8861255 13.5416667,18.7533503 L13.5416667,18.7533503 Z",
    id: "Path"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataBroadcast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-broadcast.1cf5c9b8.svg";
export { ForwardRef as ReactComponent };